module.exports = __webpack_public_path__ + "img/01.2f9809a4.png";